import { ref, onValue } from "firebase/database";
import { useEffect, useState } from "react";
import { auth, database } from "../firebase";

const History = () => {
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = auth?.currentUser;
    if (!user) return;

    const surveysRef = ref(database, `SurveyTaken/${user.uid}`);
    const unsubscribe = onValue(surveysRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const surveyList = Object.entries(data).map(([id, survey]) => ({
          id,
          ...survey,
        }));
        setSurveys(surveyList);
      } else {
        setSurveys([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h3 style={styles.highlightedTitle}>Survey History</h3>
        {loading ? (
          <div style={styles.loaderWrapper}>
            <div style={styles.loader}></div>
            <p style={styles.loadingText}>Loading your survey history...</p>
          </div>
        ) : surveys.length === 0 ? (
          <p style={styles.noDataText}>You haven't taken any surveys yet.</p>
        ) : (
          surveys.map((survey) => (
            <div key={survey.id} style={styles.card} className="history-card">
              <div style={styles.cardContent}>
                <div style={styles.title}>
                  #{survey.surveyId} — {survey.title}
                </div>
                <div style={styles.reward}>🪙 {survey.reward}</div>
              </div>
              <div style={styles.timestamp}>
                {new Date(survey.timestamp).toLocaleString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                })}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default History;

const styles = {
  wrapper: {
    background: "linear-gradient(to bottom right, #F3EBFF, #ffffff)",
    minHeight: "100vh",
    padding: "40px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    width: "100%",
    maxWidth: 960,
    animation: "fadeIn 0.6s ease-in-out",
  },
  highlightedTitle: {
    fontSize: 28,
    fontWeight: 800,
    background: "linear-gradient(to right, #8F27FF, #15007d)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textAlign: "center",
    marginBottom: 36,
    letterSpacing: 1,
    textTransform: "uppercase",
    animation: "slideDown 0.5s ease-out",
  },
  loaderWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 60,
  },
  loader: {
    width: 48,
    height: 48,
    border: "6px solid #f3f3f3",
    borderTop: "6px solid #15007d",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: "#15007d",
    fontWeight: "600",
    animation: "pulse 1.5s ease-in-out infinite",
  },
  noDataText: {
    fontSize: 16,
    color: "#666",
    textAlign: "center",
    fontWeight: 500,
    marginTop: 40,
  },
  card: {
    background: "#fff",
    border: "2px solid #8F27FF",
    borderRadius: 12,
    padding: 20,
    marginBottom: 16,
    boxShadow: "0 6px 20px rgba(143, 39, 255, 0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  title: {
    fontWeight: 700,
    fontSize: 16,
    color: "#200D41",
    background: "linear-gradient(to right, #15007d, #8F27FF)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  reward: {
    fontSize: 15,
    fontWeight: 600,
    color: "#b8860b",
  },
  timestamp: {
    fontSize: 14,
    fontWeight: 600,
    color: "#15007d",
    textAlign: "right",
    whiteSpace: "nowrap",
  },
};
